export enum ToastType {
  Success = "success",
  Info = "info",
  Warning = "warning",
  Error = "error",
}

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

export interface ToastWithTimer extends Toast {
  /** Initial duration in milliseconds */
  duration: number;
  /** Whether the toast is currently paused */
  isPaused: boolean;
  /** Whether the toast is in appearing animation state */
  isAppearing: boolean;
}
